import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  auth: null,
  user: {},
  loadingUserInfo: true,
};

const authSlice = createSlice({
  name: "Auth Provider",
  initialState,
  reducers: {
    setAuth(state, action) {
      state.auth = action.payload;
    },
    setUser(state, action) {
      state.user = action.payload;
    },
    setLoadingUserInfo(state, action) {
      state.loadingUserInfo = action.payload;
    },
    updateUsername(state, action) {
      state.user.name = action.payload;
    },
    updateUser(state, action) {
      const subject = action.payload.subject;

      state.user[subject] = action.payload.value;
    },
  },
});

export const authProviderActions = authSlice.actions;

export default authSlice.reducer;
